import React from 'react'
import {
  Box,
  Heading,
} from '@chakra-ui/react';
import SearchSlow from 'app/components/SearchSlow'
import useTokensAnalytics from 'app/features/analytics/hooks/useTokensAnalytics'
import useFuse from 'app/hooks/useFuse'
import TokenList from './TokenList';

export default function TokenBox() {
  const tokens = useTokensAnalytics()

  const options = {
    keys: ['token.id', 'token.symbol', 'token.name', 'token.strategy.apy'],
      threshold: 0.4,
  }

  const {
    result,
    term,
    search,
  } = useFuse({
    data: tokens,
    options: options,
  })
  return (
    <>
      <Box className="swap_main staking_main">
        <Box className='text_img text_imgv2'>
          <Heading as="h6">Staking</Heading>
          <Box className='search_btn_stak'>
            <SearchSlow search={search} term={term} />
          </Box>
        </Box>
        <Box className='def_table'>
          <TokenList tokens={result} term={term} />
        </Box>
      </Box>
    </>
  )
}
